<web-section-title *ngIf="showSectionTitle" [title]="sectionTitle" [svgIcon]="data.svgIcon ? data.svgIcon : null"
  [icon]="data.icon ? data.icon : null"></web-section-title>

<div class="category-text text-content" *ngIf="category?.text?.length>0" [innerHTML]="category.text | safeHtml"></div>

<div class="info-message"
  *ngIf="!this.authService.user && category && category.locationObservatoryID && category.publicPrivate">
  <div [innerHTML]="'general.publicPrivateText'|translate"></div><br />
  <button mat-flat-button color="primary"
    (click)="publicPrivateLogin()">{{'general.publicPrivateLink'|translate}}</button>
</div>

<div class="separator" *ngIf="category?.text?.length>0"></div>

<section [class.disposition-list]="disposition === DISPOSITION_LIST"
  [class.disposition-grid]="disposition === DISPOSITION_GRID">
  <ng-container *ngIf="filter">
    <article class="item"
      *ngFor="let item of items$ | async | paginate: { id: 'registers', itemsPerPage: quantity, currentPage: (page + 1), totalItems: total }; let i = index"
      [routerLink]="item[itemKeyName] + '/' + (item.title | slug)">
      <ng-container *ngTemplateOutlet="itemTemplate; context: {item: item, index: i}"></ng-container>
    </article>
  </ng-container>
  <ng-container *ngIf="!filter">
    <article *ngFor="let item of items$ | async; let i = index" class="item"
      [routerLink]="item[itemKeyName] + '/' + (item.title | slug)">
      <ng-container *ngTemplateOutlet="itemTemplate; context: {item: item, index: i}"></ng-container>
    </article>
  </ng-container>
</section>

<!-- Paginación -->
<nav class="pagination" *ngIf="paginate">
  <pagination-controls class="web-pagination" (pageChange)="loadPage($event)"
    [previousLabel]="'general.previousPage' | translate" [nextLabel]="'general.nextPage' | translate"
    [responsive]="true" [autoHide]="true" id="registers"></pagination-controls>
</nav>

<div *ngIf="(items$ | async)?.length==0" class="no-content">{{'general.noContent' | translate}}</div>

<ng-template #itemTemplate let-item="item">
  <img *ngIf="showImage && item.image" class="image" [src]="item.image" [alt]="item.title|truncate:30"
    (error)="image.src='../../../../../assets/img/default.webp'" #image loading="lazy">
  <div class="info">
    <time *ngIf="item.date">{{item.date | date:'mediumDate'}}</time>
    <p class="observatory" *ngIf="item.observatoryName">{{item.observatoryName}}</p>
    <p class="category" *ngIf="showCategory">{{item.categoryName}}</p>
    <h4 class="title">{{item.title}}</h4>
    <div class="text text-content num-lines-3" [innerHTML]="item.text|safeHtml"></div>
  </div>
</ng-template>